import { LOYALTY_POINTS_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TLoyaltyPointsSelector, TEqualityFunction } from '../types';

export const useLoyaltyPointsSelector =
    <TSelected>(selector: TLoyaltyPointsSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
        return useCustomSelector<TSelected, typeof LOYALTY_POINTS_REDUCER>(LOYALTY_POINTS_REDUCER, selector, equalityFn);
    };
